// extracted by mini-css-extract-plugin
export default {"OpcHeader":"OpcHeader_OpcHeader__ORtNp","image":"OpcHeader_image__rHYBn","text":"OpcHeader_text__xuSZA","title":"OpcHeader_title__Xlmy0","subtitle":"OpcHeader_subtitle__gWp4P"};